import { useContext, useEffect, useState } from "react"
import { Button, Card, DatePicker, Divider, Form, Input, notification } from "antd"
import dayjs from "dayjs"
import { Event } from "../api.types"
import { CurrentUserContext, useHttp } from "../Context"
import { Link, useNavigate } from "react-router-dom";
import { t } from "i18next"
import { GameEntryView, toGameEntryView } from "../model/gameEntryView"
import { EventSocialsHelper } from "./EventSocialsHelper"


export function EventEdit(props: { eventId: string | undefined }) {
    const [eventState, setEventState] = useState<{
        name: string,
        participantCount: number,
        gameCount: number,
        date: dayjs.Dayjs,
        propositionsDeadline?: dayjs.Dayjs,
        preferencesDeadline?: dayjs.Dayjs,
        short?: string
    }>({
        name: "",
        gameCount: 0,
        participantCount: 0,
        date: dayjs().minute(0).second(0)
    })
    const [event, setEvent] = useState<Event>()

    const { currentUser } = useContext(CurrentUserContext)
    const httpFetch = useHttp()
    const fetchEvent = () => {
        if (props.eventId === undefined) {
            return
        }
        httpFetch(`/api/event/${props.eventId}`).then((resp: any) => {
            resp.json().then((data: Event) => {
                setEventState({
                    name: data.name,
                    participantCount: data.participantCountLimit || 0,
                    gameCount: data.gamePropositionCountLimit || 0,
                    date: data.eventDate ? dayjs(data.eventDate) : dayjs(),
                    preferencesDeadline: data.preferencesDeadline ? dayjs(data.preferencesDeadline) : undefined,
                    propositionsDeadline: data.propositionsDeadline ? dayjs(data.propositionsDeadline) : undefined,
                    short: data.short
                })
                setEvent(data)
            })
        })
    }
    const navigate = useNavigate()
    const [notifications, contextHolder] = notification.useNotification();
    const saveEvent = () => {
        httpFetch(`/api/event/${props.eventId || "_"}`, {
            method: "PUT", body: JSON.stringify({
                name: eventState.name,
                participantCountLimit: eventState.participantCount,
                gamePropositionCountLimit: eventState.gameCount,
                eventDate: eventState.date.toJSON(),
                preferencesDeadline: eventState.preferencesDeadline?.toJSON(),
                propositionsDeadline: eventState.propositionsDeadline?.toJSON(),
                short: eventState.short
            })
        }).then((resp: any) => {
            resp.json().then((data: Event) => {
                notifications.success({ message: "Zapisano", duration: 5, showProgress: true, pauseOnHover: true })
                if (props.eventId) {
                    fetchEvent()
                } else {
                    navigate("/event/" + data.id + "/edit")
                }
            })
        })
    }
    useEffect(fetchEvent, [props.eventId, currentUser, httpFetch])
    const addWeek = () => {
        setEventState((c) => {
            return Object.assign({}, c, {
                date: c.date ? c.date.add(1, 'week') : c.date,
                preferencesDeadline: c.preferencesDeadline ? c.preferencesDeadline.add(1, 'week') : c.preferencesDeadline,
                propositionsDeadline: c.propositionsDeadline ? c.propositionsDeadline.add(1, 'week') : c.propositionsDeadline,
            })
        })
    }

    let gameEntries: GameEntryView[] = []
    if (event) {
        gameEntries = toGameEntryView(event)
    }

    return (
        <>
            <Card>
                {contextHolder}
                {props.eventId ? <><Link to={"/event/" + props.eventId}>{t("Event page")}</Link><hr /></> : undefined}

                <Form.Item label="nazwa wydarzenia">
                    <Input type="text" value={eventState.name} onChange={(e) => setEventState(Object.assign({}, eventState, { name: e.target.value }))} />
                </Form.Item>

                <Form.Item label="liczba graczy">
                    <Input type="number" value={eventState.participantCount} onChange={(e) => setEventState(Object.assign({}, eventState, { participantCount: +e.target.value }))} />
                </Form.Item>

                <Form.Item label="liczba gier">
                    <Input type="number" value={eventState.gameCount} onChange={(e) => setEventState(Object.assign({}, eventState, { gameCount: +e.target.value }))} />
                </Form.Item>

                <Form.Item label="data wydarzenia">
                    <DatePicker
                        value={eventState.date}
                        type="date"
                        showTime={{ format: "HH:mm", minuteStep: 5 }}
                        showNow={false}
                        allowClear={false}
                        onChange={(dat) => setEventState(Object.assign({}, eventState, { date: dat }))}
                    />
                </Form.Item>

                <Form.Item label="deadline propozycji">
                    <DatePicker
                        value={eventState.propositionsDeadline}
                        type="date"
                        showTime={{ format: "HH:mm", minuteStep: 5 }}
                        showNow={false}
                        onChange={(dat) => setEventState(Object.assign({}, eventState, { propositionsDeadline: dat }))}
                        maxDate={eventState.date}
                    />
                </Form.Item>

                <Form.Item label="deadline preferencji">
                    <DatePicker
                        value={eventState.preferencesDeadline}
                        type="date"
                        showTime={{ format: "HH:mm", minuteStep: 5 }}
                        showNow={false}
                        onChange={(dat) => setEventState(Object.assign({}, eventState, { preferencesDeadline: dat }))}
                        maxDate={eventState.date}
                    />
                </Form.Item>
                <Divider />
                <Form.Item label="short link">
                    <Input type="text" value={eventState.short} onChange={(e) => setEventState(Object.assign({}, eventState, { short: e.target.value }))} />
                </Form.Item>
                <Divider />
                <Button type="primary" onClick={saveEvent}>{t("Save")}</Button>
                <Divider />
                {
                    props.eventId ?
                        <Button type="default"><Link to={"/event/_/edit"}>{t("Clone")}</Link></Button> :
                        undefined
                }
                <Button type="default" onClick={addWeek}>{t("+week")}</Button>
            </Card>
            <EventSocialsHelper eventId={props.eventId} event={event} gameEntries={gameEntries}/>
        </>
    )

}

